module.exports = __webpack_public_path__ + "static/media/United States of America - US.8338d232.png";